import React from 'react'
import FooterLogo from '../components/FooterLogo'

const Rules = () => {
  return (
    <>
      <div className="page-container col-sm-9 clearfix">
        <div id="rules-header">
          <div id="header-rules-text">
            <span className="count-down">Rules & Regulations</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">1. Rule</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Have fun.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">2. Rule</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Read the rules.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">3. Getting Started</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Register online. Select your home court and enter your rating. If you do not have a rating, you can self-rate for the first season. Your results will determine if you stay at your self-rated level. Registration is always free, and you can use the message system to communicate with other members.</p>
                  <p>To enter league / tournament play, you will pay a nominal fee. The fee will be clearly posted. You will receive notification when registration is open for league play via email, banners on the Open Play Tennis website or both.</p>
                  <p>League play is generally 4 weeks + a 16-player singles elimination playoff if you qualify. The top 16 players will qualify for the single elimination playoff based on ranking (see league scoring for information on ranking). You have a week to play each match. Your schedule will populate on the player profile page once the season begins. </p>
                  <p>You contact your opponent via the online message system, schedule and play your match and post your results online. </p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">4. Format</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>The format for the league two out of three traditional 6 games sets.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">5. League Scoring</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Scoring is not based on a win / loss record, rather a point system. The point system for league play is as follows:</p>
                  <div className="col-lg-6">
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Straight set match win</div>
                      <div className="col-4 pl-0">= 4 points</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Match win</div>
                      <div className="col-4 pl-0">= 3 points</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Opponent retired</div>
                      <div className="col-4 pl-0">= 3 points</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Default victory</div>
                      <div className="col-4 pl-0">= 2 points</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">BYE</div>
                      <div className="col-4 pl-0">= 2 points</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Losing player winning a set</div>
                      <div className="col-4 pl-0">= 1 point</div>
                    </div>
                    <div className="row pt-2">
                      <div className="col-6 pl-0">Players loses in straight sets</div>
                      <div className="col-4 pl-0">= 0 point</div>
                    </div>
                  </div>
                  <p className="pt-3">Players with higher number of points will be higher in rank on the leaderboard. If two or more players have the same number of points then the player with a greater number of wins will be higher in rank. If two or more players have equal points and equal wins then player with the higher winning percentage of games won will be ranked higher on the leaderboard. If players are still tied, then the player with less number of loses will be higher on leaderboard ranking.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">6. Bye</h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Some players will have a bye on their schedule. A bye counts for two points.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">7. Default </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>If a player cannot play, or a player does not show up for a match, then a default victory is awarded. A default victory counts for two points. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">8. Opponent Retired </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>If a match has started and one of the players can not complete the match for any reason – injury, emergency, etc. – then the player that is able to continue has the option of rescheduling or taking an opponent retired victory. Opponent retired counts for three points. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">9. Schedule / Scheduling </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Schedules will be available prior to the start of the season and are posted within 24 hours of registration closing. Players will have two home matches and two away matches. Some players may have a "bye" during the four-week season. </p>
                  <p>You have a week to complete each match. It is the responsibility of the home court player to initiate contact with his/her opponent. Use the online message system to contact your opponent. To make scheduling easier, you may want to exchange phone numbers. </p>
                  <p>If a player cannot play, the player who can play has the option of rescheduling or taking a default victory. Please make every effort to play each match - even if rescheduling is required </p>
                  <p>If both players agree, you may play matches before the scheduled date. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">10. Unrosponsive Opponent </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>If a player does not respond to efforts to schedule a match, please email the tournament chairman for help ( <a href="mailto:tchair@openplaytennis.com">tchair@openplaytennis.com</a> ). If the player remains nonresponsive, you will enter a default victory. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">11. Posting Scores </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>To post scores log in and go to the schedule page, click on the match, and enter your scores. Only the scheduled players can enter their scores. If a mistake is made while posting, please contact the tournament chairman for help (<a href="mailto:tchair@openplaytennis.com">tchair@openplaytennis.com</a>). </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">12. Eligibility </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Open Play Tennis is open to both male and female players. The only requirement is a rating. USTA or UTR ratings are preferred, but you can self-rate for the first season. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">13. Balls </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>The home court player is responsible for providing USTA approved balls. During COVID however, each player should bring their own balls and serve with the can of balls they brought. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">14. Levels </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Player will be bracketed into levels based on rating. We have levels for 2.5 – 5.0 players. Players may opt to play up one level, but players are not allowed to play down. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">15. Division Size </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>If less than 6 players register for a division, players will be notified via email and given the option to continue play or receive a refund. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">16. Age </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>
                    We ask that you be at least 13 to play in the Open Play Tennis League. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">17. Courts </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Select your home court from the registration page. The Open Play Tennis administer will verify the court. Once the administrator verifies the court, the court will appear on your player Profile Page and Court Page </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">18. Court Fees </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p> Please choose a court that does not require a fee. If you do select a court that requires a fee, you are responsible for paying for opponent as well as yourself.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">19. Warm Up
                </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p> Warm up should be limited to 10 minutes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">20. Coaching </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>If you think it will help, knock yourself out. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">21. Playoffs </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>Top 16 players from each level qualify for the playoffs. See Rules for tie-breaker information. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">22. Message Boards </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p> The message system – both your personal player profile message system and the public message board are used to communicate between players. Your comments should be limited to something you can say to your ten-year-old niece or your eighty-year-old grandmother. In other words, please keep it clean!</p>
                  <p> If you receive an inappropriate email, you can pass it on to the administrator for review. If your email is found to be offensive, you may be disciplined up to and including removal from the website. We hope we never have to enforce this rule. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="rules-box-container">
              <div className="heading-rule text-light">
                <h3 className="text-light p-0">23. Final Thoughts </h3>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <p>BE A GOOD SPORT. If you do not clearly see a ball out, then it is in. Try and settle all disagreements on the court. If for some reason you cannot settle a dispute, please email: <a href="mailto:tchair@openplaytennis.com">tchair@openplaytennis.com</a> . </p>
                  <p>Remember the FIRST RULE and have fun. Now go beat Joe!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer_space'></div>
      <FooterLogo />
    </>
  )
}

export default Rules